import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getSimilarity } from '../../../../redux/form/selectors';
import { changeSimilarity } from '../../../../redux/form/actions';
import PanelInputField from '../PanelInputField';
import RangeSlider from '../RangeSlider';
import LabelText from '../LabelText';
const ImageSimilaritySliderField = ()=>{
    const { t } = useTranslation('dreamup');
    const similarity = useSelector(getSimilarity);
    const dispatchChangeSimilarity = useAction(changeSimilarity);
    const handleChange = useCallback((e)=>{
        dispatchChangeSimilarity(parseInt(e.target.value));
    }, [
        dispatchChangeSimilarity
    ]);
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "label",
        label: /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.similarity.label')),
        input: /*#__PURE__*/ React.createElement(RangeSlider, {
            name: "similarity",
            value: similarity,
            onChange: handleChange,
            min: 1,
            max: 100,
            step: 1,
            displayValue: `${similarity}%`
        })
    });
};
ImageSimilaritySliderField.displayName = 'ImageSimilaritySliderField';
export default ImageSimilaritySliderField;

//# sourceMappingURL=ImageSimilaritySliderField.js.map